<template>
  <b-navbar toggleable type="dark" variant="dark">
    <b-container>
      <b-navbar-brand href="#">Управление подписками</b-navbar-brand>
      <b-navbar-toggle target="navbar-toggle-collapse" @click.native="checkAuth">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isAuth" href="#" @click="logout">Выйти</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      isAuth: false
    }
  },
  // Добавлено: проверка при загрузке страницы
  created() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.isAuth = localStorage.getItem('jwt') !== null;
    },
    logout(e) {
      e.preventDefault();
      this.$http.post(`${process.env.VUE_APP_API_URL}/auth/logout/`, {}).then(response => {
        if (response.status === 200) {
          localStorage.removeItem('jwt');
          this.isAuth = false;
          this.$router.push({name: 'login'});
        }
      })
          .catch(error => {
            localStorage.removeItem('jwt');
            this.isAuth = false;
            this.$router.push({name: 'login'});
          });
    }
  }
}
</script>